<template>
  <div v-if="$root.adminInfo.id">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'gicTeleport',
  props: {
      /* 移动至哪个标签内，最好使用id */
      to: {
          type: String,
          required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
  },
  watch: {
    disabled: {
      handler(nv) {
        // 当disabled属性由false变为true时，将dom从body移动回原来的父级
        if (nv) {
          this.oldParentNode.appendChild(this.$el);
        } 
      }
    }
  },  
  mounted() {
    this.oldParentNode = this.$el.parentNode;
    if (!this.disabled) {
      document.querySelector(this.to).appendChild(this.$el)
    }
  },
  destroyed() {
    if (!this.disabled) {
      document.querySelector(this.to).removeChild(this.$el)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmTeleport.vue